import { Link } from 'components/elements';
import { StyledIcon } from 'components/elements/Icon/Icon.styled';
import { css, styled } from 'styles';

const baseStyles = css`
  align-items: center;
  border-bottom: medium solid ${({ theme }) => theme.breadcrumbs.border};
  display: flex;
  font-weight: 500;
  padding: ${({ theme }) => theme.spacing.absolute.small}
    ${({ theme }) => theme.spacing.absolute.smaller};
  text-transform: uppercase;
  white-space: nowrap;

  &:last-child {
    border-color: ${({ theme }) => theme.breadcrumbs.highlight};
  }
`;

export const BreadcrumbsBranch = styled(Link)`
  ${baseStyles};
`;

export const BreadcrumbsChevron = styled.div`
  ${baseStyles};

  color: ${({ theme }) => theme.breadcrumbs.chevron};
  padding-left: 0;
  padding-right: 0;
`;

export const BreadcrumbsHome = styled(Link)`
  ${baseStyles};
  color: ${({ theme }) => theme.breadcrumbs.icon};

  ${StyledIcon} {
    font-size: 1.4em;
  }
`;

export const BreadcrumbsLeaf = styled.div`
  ${baseStyles};
`;

export const StyledBreadcrumbs = styled.div`
  display: flex;
  font-size: 0.8em;
  overflow: hidden;
  user-select: none;

  @media (max-width: 576px) {
    flex-direction: column;

    ${BreadcrumbsBranch} {
      border-bottom: unset;
    }

    ${BreadcrumbsBranch},
    ${BreadcrumbsLeaf} {
      padding-left: 0;
      padding-right: 0;
    }

    ${BreadcrumbsChevron},
    ${BreadcrumbsHome} {
      display: none;
    }
  }
`;

BreadcrumbsBranch.displayName = 'BreadcrumbsBranch';
BreadcrumbsChevron.displayName = 'BreadcrumbsChevron';
BreadcrumbsHome.displayName = 'BreadcrumbsHome';
BreadcrumbsLeaf.displayName = 'BreadcrumbsLeaf';
StyledBreadcrumbs.displayName = 'Breadcrumbs.Styled';
